module.exports = __webpack_public_path__ + "img/larissa.4f7d2928.png";